const allMenuItems = [
	{ key: "0", text: "Profile", link: "/profile/settings" },
	{ key: "1", text: "Notifications", link: "/profile/inbox" },
	{ key: "2", text: "History", link: "/profile/history" },
	{ key: "3", text: "Documents", link: "/profile/documents" },
	{ key: "4", text: "My Bonuses", link: "/profile/bonuses" },
	{ key: "5", text: "Cashback", link: "/profile/cashback" },
	{ key: "6", text: "Deposit", link: "/profile/deposit" },
	{ key: "7", text: "Withdraw", link: "/profile/withdraw" },
	{ key: "8", text: "Account insights", link: "/profile/account-insights" },
	{ key: "9", text: "Limits", link: "/profile/limits" },
];

export const getMenuItems = () =>
	allMenuItems.filter((item) => {
		if (item.link === "/profile/account-insights") {
			return window.PROFILE_INSIGHTS_MODULE !== false;
		}

		if (item.link === "/profile/limits") {
			return Array.isArray(window.PROFILE_LIMITS_MODULE) && window.PROFILE_LIMITS_MODULE.length > 0;
		}

		return true;
	});

export const menuItems = getMenuItems();

export const dropdownItems = [
	{ key: "game", value: "GAME" },
	{ key: "deposit", value: "PAYMENT" },
	{ key: "pending_withdraw", value: "PENDING_PAYMENT" },
];
